import { httpGet } from "../../utilities/TZMRequest";

export class OperadorService {

	listar(params) {
		return httpGet("/operadores", params);
	}

}
